import MyOlympics from "../MyOlympics/component";

/**
 * This function handles the rendering of MyOlympics Widget or Page
 *
 * @param {Object} params the widget params
 *
 * @returns {JSX} component for MyOlympics Widget or page
 */
const MyOlympicsContainer = ({ params }) => {
    const { myolympics } = params;

    if (!myolympics || !myolympics.options) {
        return;
    }
    const options = JSON.parse(myolympics.options);

    return <MyOlympics headline={params?.title} params={options} />;
};

export default MyOlympicsContainer;
